<template>
  <div
    class="select-dropdown"
    :class="[{ 'is-multiple': isMultiple }, popperClass]"
    :style="{ minWidth: minWidth }"
    @mousedown.stop
  >
    <div v-if="$slots.header" class="select-dropdown-header">
      <slot name="header"></slot>
    </div>
    <slot></slot>
    <div v-if="$slots.footer" class="select-dropdown-footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script lang="ts">
import {
  defineComponent,
  computed,
  onMounted,
  inject,
  ref,
} from 'vue'
import { useResizeObserver } from '@vueuse/core'
import { selectKey } from './token'

export default defineComponent({
  name: 'SelectDropdown',

  componentName: 'SelectDropdown',

  setup() {
    const select = inject(selectKey)

    // computed
    const popperClass = computed(() => select.props.popperClass)
    const isMultiple = computed(() => select.props.multiple)
    const minWidth = ref('')

    function updateMinWidth() {
      minWidth.value = select.selectWrapper?.getBoundingClientRect().width + 'px'
    }

    onMounted(() => {
      // TODO: updatePopper
      // popper.value.update()

      useResizeObserver(select.selectWrapper, updateMinWidth)

    })

    return {
      minWidth,
      popperClass,
      isMultiple,
    }
  },
})
</script>
